import { JSXElement } from '@/common/types';
import { useCloudAuth } from '@itential/cloud-auth-client';
import { setCloudAuthStateRef } from '@/services/token.service';
import { PropsWithChildren, useEffect } from 'react';

export function AuthStateInitializer({ children }: PropsWithChildren): JSXElement {
    const { state } = useCloudAuth();

    useEffect(() => {
        setCloudAuthStateRef(state);
    }, [state]);

    return <>{children}</>;
}
